import { DocumentState } from 'components/common/dataGrid/columnsFactory/types';
import { useOpenDocumentationFileFromUrl } from './useOpenDocumentationFileFromUrl';
import { useGalleryUrlSynchronization } from './useGalleryUrlSynchronization';

export { isNavigatingOutside, signalNavigationOutsideDocumentation } from './navigationGuard';

/**
 * Documentation URL <-> gallery: opens the file from a file URL and keeps the
 * URL in line with the gallery afterwards.
 */
export function useDocumentationUrlNavigation(
  clearFilterAndSortModel: (state: DocumentState) => void,
  isDocumentationListLoading: () => boolean,
  onDialogVisibilityChange: (isOpen: boolean) => void,
  isDocumentationDialogOpen = false
): void {
  const fileToOpenRef = useOpenDocumentationFileFromUrl(
    clearFilterAndSortModel,
    isDocumentationListLoading,
    onDialogVisibilityChange
  );
  useGalleryUrlSynchronization(isDocumentationDialogOpen, fileToOpenRef);
}
